import { render, staticRenderFns } from "./AccessCells.vue?vue&type=template&id=47185e22&"
import script from "./AccessCells.vue?vue&type=script&lang=js&"
export * from "./AccessCells.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports